module.exports = __webpack_public_path__ + "static/media/WHY_WBN_CONNECTED.9a812cde.png";